import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Play, PlayCircle } from "@phosphor-icons/react"

const ImageThumb = ({image, index, onClick, selected, maxHeight = 'max-h-16 md:max-h-26 lg:max-h-30', isVideoThumbnail = false }) => {
    
    return (
        <React.Fragment>
            <div className={`relative shrink-0 lg:shrink-1 md:max-w-26 lg:max-w-21 ${maxHeight} overflow-hidden cursor-pointer ${selected === index ? 'border-2 border-black opacity-100' : 'opacity-50'}`} onClick={onClick}>
                {isVideoThumbnail && (
                    <Play className="absolute z-50 bg-white rounded-full p-2 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" size={32} weight="fill" />
                )}
                <GatsbyImage
                    className="w-full lg:w-auto h-full"
                    objectFit="contain"
                    loading="lazy"
                    alt="Product thumbnail"
                    image={image ?? image}
                    aria-label={'check-product-photo'}
                />
            </div>
        </React.Fragment>
    )
}

export default ImageThumb